
import { createContext, useContext, useEffect, useState } from "react";
import api from "../api";

const AuthContext = createContext();

export function AuthProvider({ children }) {

    const [user, setUser] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        async function checkLogin() {

            const token = localStorage.getItem("access_token");

            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const response = await api.get("/auth/me");
                setUser(response.data);
            } catch {
                setUser(null);
            } finally {
                setLoading(false);
            }
        }

        checkLogin();

    }, []);

    return (

        <AuthContext.Provider value={{

            user,

            setUser,

            loading,

            setLoading

        }}>

            {children}

        </AuthContext.Provider>

    );

}

export function useAuth() {

    return useContext(AuthContext);

}